import { Steps } from 'antd';
import { MainLayout } from 'components';
import { ReactNode, useEffect } from 'react';
import useCategoryManagementStore from 'store/categoryManagementStore';
import { CheckIcon } from 'assets/svg';
import pageTitleStore from 'store/pageTitleStore';

interface IProps {
  children: ReactNode;
  isLoading?: boolean;
}

export default function AddCategoryPage(props: IProps): JSX.Element {
  const { children, isLoading } = props;
  const step = useCategoryManagementStore((state) => state.step);
  const infoSteps = [
    {
      title: 'Khai báo danh mục',
      icon: <>{step >= 1 ? <CheckIcon /> : '1'}</>,
      className: 'step-first',
    },
    {
      title: 'Danh sách sản phẩm',
      icon: <>{step >= 2 ? <CheckIcon /> : '2'}</>,
      className: 'step-mid',
    },
    {
      title: 'Thiết lập phê duyệt',
      icon: <>{step >= 3 ? <CheckIcon /> : '3'}</>,
      className: 'step-last',
    },
  ];
  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);
  useEffect(() => {
    setTitle('Tạo danh mục');
    setBreadcrumb([
      {
        title: <a href="/category">Danh mục</a>,
      },
      { title: <a href="/add-category/category-info-step">Tạo danh mục</a> },
    ]);
  }, []);

  return (
    <MainLayout isLoading={isLoading}>
      <Steps
        current={step}
        className="add-category-step mb-7"
        items={infoSteps}
      />
      <div className="p-1">{children}</div>
    </MainLayout>
  );
}
